// extracted by mini-css-extract-plugin
export default {"details":"LaunchInfoModal_details__Ggtoq"};